<template>
    <span :class="{
        'help-block': true,
        'mb-0': noBottomMargin,
        'mt-0': noTopMargin,
    }">
        <slot></slot>
    </span>
</template>

<style lang="scss" scoped>
    .mb-0 {
        margin-bottom: 0;
    }
    .mt-0 {
        margin-top: 0;
    }
</style>

<script>
export default {
    props: {
        noBottomMargin: {
            type: Boolean,
            required: false,
            default: false,
        },
        noTopMargin: {
            type: Boolean,
            required: false,
            default: false,
        },
    }
}
</script>